"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitializedPlugins = exports.getEnabledPlugins = exports.enablePlugins = void 0;
const constants_1 = require("./constants");
const lodash_merge_1 = __importDefault(require("lodash.merge"));
/**
 * Enables all plugins that need manual enablement
 *
 * @param enabledPlugins default plugins that are enabled
 */
const enablePlugins = (enabledPlugins) => {
    enabledPlugins.forEach((plugin) => {
        if (plugin.enablePlugin !== undefined) {
            plugin.enableConfiguration === undefined
                ? plugin.enablePlugin()
                : plugin.enablePlugin(plugin.enableConfiguration);
        }
    });
};
exports.enablePlugins = enablePlugins;
/**
 * Filters the combined object maps for just the enabled plugins
 *
 * @param pluginConfiguration - plugin configuration options passed in by the user
 */
const getEnabledPlugins = (pluginConfiguration = {}) => {
    const map = getPluginMap(pluginConfiguration.defaultPluginConfigurationOverrides);
    const enabledDefaultPlugins = Object.values(map).filter((plugin) => {
        return plugin.enabled;
    });
    if (pluginConfiguration.additionalPlugins !== undefined) {
        return [...enabledDefaultPlugins, ...pluginConfiguration.additionalPlugins];
    }
    return enabledDefaultPlugins;
};
exports.getEnabledPlugins = getEnabledPlugins;
/**
 * Creates the BrowserPlugin[] list to be instantiated in the Snowplow tracker
 *
 * @param enabledPlugins default plugins that are enabled
 */
const getInitializedPlugins = (enabledPlugins) => {
    return enabledPlugins.map((plugin) => {
        if (plugin.plugin !== undefined) {
            return plugin.plugin();
        }
        return {};
    });
};
exports.getInitializedPlugins = getInitializedPlugins;
/**
 * Combines the default plugins map with a user supplied override, if one is present
 *
 * @param defaultPluginOverrides - any overrides to the default plugins passed in by the user
 */
const getPluginMap = (defaultPluginOverrides = {}) => {
    return (0, lodash_merge_1.default)(constants_1.DEFAULT_PLUGINS, defaultPluginOverrides);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcGx1Z2lucy91dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFPQSwyQ0FBOEM7QUFDOUMsZ0VBQWlDO0FBRWpDOzs7O0dBSUc7QUFDSCxNQUFNLGFBQWEsR0FBRyxDQUFDLGNBQThCLEVBQVEsRUFBRTtJQUMzRCxjQUFjLENBQUMsT0FBTyxDQUFDLENBQUMsTUFBb0IsRUFBUSxFQUFFO1FBQ2xELElBQUksTUFBTSxDQUFDLFlBQVksS0FBSyxTQUFTLEVBQUU7WUFDbkMsTUFBTSxDQUFDLG1CQUFtQixLQUFLLFNBQVM7Z0JBQ3BDLENBQUMsQ0FBQyxNQUFNLENBQUMsWUFBWSxFQUFFO2dCQUN2QixDQUFDLENBQUMsTUFBTSxDQUFDLFlBQVksQ0FBQyxNQUFNLENBQUMsbUJBQW1CLENBQUMsQ0FBQztTQUN6RDtJQUNMLENBQUMsQ0FBQyxDQUFDO0FBQ1AsQ0FBQyxDQUFDO0FBK0NPLHNDQUFhO0FBN0N0Qjs7OztHQUlHO0FBQ0gsTUFBTSxpQkFBaUIsR0FBRyxDQUFDLHNCQUEyQyxFQUFFLEVBQWtCLEVBQUU7SUFDeEYsTUFBTSxHQUFHLEdBQW1CLFlBQVksQ0FDcEMsbUJBQW1CLENBQUMsbUNBQW1DLENBQzFELENBQUM7SUFDRixNQUFNLHFCQUFxQixHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsTUFBb0IsRUFBRSxFQUFFO1FBQzdFLE9BQU8sTUFBTSxDQUFDLE9BQU8sQ0FBQztJQUMxQixDQUFDLENBQUMsQ0FBQztJQUVILElBQUksbUJBQW1CLENBQUMsaUJBQWlCLEtBQUssU0FBUyxFQUFFO1FBQ3JELE9BQU8sQ0FBQyxHQUFHLHFCQUFxQixFQUFFLEdBQUcsbUJBQW1CLENBQUMsaUJBQWlCLENBQUMsQ0FBQztLQUMvRTtJQUVELE9BQU8scUJBQXFCLENBQUM7QUFDakMsQ0FBQyxDQUFDO0FBMkJzQiw4Q0FBaUI7QUF6QnpDOzs7O0dBSUc7QUFDSCxNQUFNLHFCQUFxQixHQUFHLENBQUMsY0FBOEIsRUFBbUIsRUFBRTtJQUM5RSxPQUFPLGNBQWMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxNQUFvQixFQUFpQixFQUFFO1FBQzlELElBQUksTUFBTSxDQUFDLE1BQU0sS0FBSyxTQUFTLEVBQUU7WUFDN0IsT0FBTyxNQUFNLENBQUMsTUFBTSxFQUFFLENBQUM7U0FDMUI7UUFDRCxPQUFPLEVBQUUsQ0FBQztJQUNkLENBQUMsQ0FBQyxDQUFDO0FBQ1AsQ0FBQyxDQUFDO0FBYXlDLHNEQUFxQjtBQVhoRTs7OztHQUlHO0FBQ0gsTUFBTSxZQUFZLEdBQUcsQ0FDakIseUJBQThELEVBQUUsRUFDbEQsRUFBRTtJQUNoQixPQUFPLElBQUEsc0JBQUssRUFBQywyQkFBZSxFQUFFLHNCQUFzQixDQUFDLENBQUM7QUFDMUQsQ0FBQyxDQUFDIn0=


// WEBPACK FOOTER //
// ../../../src/plugins/utils.ts